//@flow
import React from 'react';
import EmailField from '../../Address/components/EmailField.react';
import Formsy from 'formsy-react';
import StockRemindersActions from '../../Actions/stockReminders';
import CustomerModel from '../../Stores/Customer/customerModel';
import CookiesData from '../../Utils/cookies-data';

type Props = {
  sku:string,
  customer:?CustomerModel,
  buttonClassName:string,
  buttonText:string,
};

type State = {
  valid:boolean,
};

export default class OutOfStockEmailForm extends React.Component<Props, State> {
  static defaultProps = {
    buttonClassName: 'cta',
    buttonText: 'Notify me',
  };

  state = { valid: false };

  setEmail(email:string) {
    const savedEmail = CookiesData.getEmail();
    if (email !== savedEmail) CookiesData.set('email', { email });
  }

  submit = (data:{email:string}) => {
    if (data.email) this.setEmail(data.email);
    const email = (this.props.customer && this.props.customer.getEmail()) || data.email;
    StockRemindersActions.setStockReminder(email, this.props.sku);
  };

  setValid = () => {
    this.setState({
      valid: true,
    });
  };

  setInvalid = () => {
    this.setState({
      valid: false,
    });
  };

  getDisabled() {
    const email = this.props.customer && this.props.customer.getEmail();
    if (!email) return !this.state.valid;
    return false;
  }

  getEmail() {
    const emailObj = CookiesData.getEmail();
    return emailObj && emailObj.email;
  }

  getValidationErrors() {
    return {
      isEmail: "Please enter a valid email address",
      maxLength: "Email is too long",
    };
  }

  render() {
    return (
      <div className="form">
        <Formsy.Form
          className="formsy-form email-form"
          onValidSubmit={this.submit}
          onInvalid={this.setInvalid}
          onValid={this.setValid}
        >
          <EmailField
            setValue={this.getEmail()}
            placeholder="Your email address"
            validationErrors={this.getValidationErrors()}
          />
          <button
            className={`${this.props.buttonClassName} out-of-stock`}
            type="submit"
            disabled={this.getDisabled()}
          >
            {this.props.buttonText}
          </button>
        </Formsy.Form>
      </div>
    );
  }
}
